<template>
  <div>
    <Counting-Menu-Top />
    <Counting-Map />
    <!-- <br> -->
    <Counting-Statistics />
    <!-- <br> -->
    <Counting-Chart />
    <!-- <br> -->
    <Counting-Line />
    <!-- <br> -->
    <Counting-Table />
  </div>
</template>

<script>
import CountingMap from '@/views/counting/total/CountingMap.vue'
import CountingStatistics from '@/views/counting/total/CountingStatistics.vue'
import CountingLine from '@/views/counting/total/CountingLine.vue'
import CountingTable from '@/views/counting/total/CountingTable.vue'
import CountingMenuTop from '@/views/counting/total/CountingMenuTop.vue'
import CountingChart from '@/views/counting/total/CountingChart.vue'
// import axios from '@axios'
export default {
  components: {
    CountingMap,
    CountingStatistics,
    CountingLine,
    CountingTable,
    CountingMenuTop,
    CountingChart,
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  },
}
</script>

  <style>
  </style>
